module.exports = __webpack_public_path__ + "images/side_menu_arrow.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/side_menu_arrow.svg
// module id = 1125
// module chunks = 0